module.exports = __webpack_public_path__ + "assets/img/3d.d55a998e.png";